import * as React from 'react'

function SvgBni(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="35"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.61376 19.6878L8.35979 18.3122C8.06878 17.9683 7.80423 17.5979 7.53968 17.2275C5.50265 14.4233 4.31217 11.5397 5.15873 9H0V11.7513L6.61376 19.6878Z"
        fill="#EF4823"
      />
      <path
        d="M9.39172 15.5873C9.49754 14.6878 9.78855 12.9947 11.4817 11.7513C12.9632 10.6667 14.815 10.455 16.4552 11.1164V9H7.32823C6.71976 11.5661 8.30707 14.4233 9.39172 15.5873Z"
        fill="#EF4823"
      />
      <path
        d="M11.5873 12.9947C9.86771 14.3439 10.291 16.4603 11.8783 18.3386C13.1217 19.7936 14.7619 20.8254 16.4286 20.0582V13.8148C14.9471 12.3333 13.1217 11.8042 11.5873 12.9947Z"
        fill="#EF4823"
      />
      <path d="M0 15.0054V24.8466L4.97355 20.9578L0 15.0054Z" fill="#EF4823" />
      <path
        d="M9.04763 19.1055C8.57144 19.5023 7.96298 19.9785 7.27515 20.4811L7.91007 21.2483C8.83599 22.3859 10.2117 24.3171 11.9048 23.788L11.9577 23.8674L10.7408 24.8198H16.4021V21.0896C13.545 22.624 11.0318 21.2219 9.04763 19.1055Z"
        fill="#EF4823"
      />
      <path
        d="M6.32296 22.5715L5.66158 21.7778C4.28592 22.836 2.83089 23.9471 1.66687 24.8466H7.98962C7.5928 24.0001 6.8256 23.2064 6.32296 22.5715Z"
        fill="#EF4823"
      />
      <path
        d="M30.1587 15.6138C31.6666 15.3492 32.6455 14.1058 32.6455 12.4921C32.6455 10.3492 30.7142 9 27.4338 9H20.8994V9.07937C22.2222 9.79365 22.1957 10.9312 22.1957 11.9894V21.8042C22.1957 22.9153 22.2222 24.0529 20.8994 24.7407V24.8201H24.0476C27.1163 24.8201 29.4708 24.873 31.2169 24.0794C33.0952 23.2328 34.2063 21.7249 34.2063 19.873C34.2328 17.5185 32.4074 16.0899 30.1587 15.6138ZM24.7618 10.455L26.8253 10.4815C28.3597 10.4815 29.9206 11.1958 29.9206 12.8624C29.9206 14.8466 28.5449 15.3757 26.5608 15.3757H24.7618V10.455ZM26.746 23.2063H24.7618V16.963V16.8836H26.9047C29.3915 16.8836 31.455 17.7831 31.455 20.1111C31.455 22.3862 29.2857 23.2063 26.746 23.2063Z"
        fill="#006788"
      />
      <path
        d="M39.2328 21.8307C39.2328 23.1799 39.2063 24.1323 40.5291 24.8995V24.9788H36.1111V24.8995C37.4338 24.1587 37.4074 23.1799 37.4074 21.8307V12.2011C37.4074 10.8519 37.4338 9.79365 36.1111 9.07937V9H39.7883V9.02646C39.8942 9.31746 40.0529 9.47619 40.1587 9.63492C40.2645 9.79365 40.5026 10.1111 40.5026 10.1111L48.9153 21.037V12.0952C48.9153 10.746 48.9418 9.79365 47.619 9.05291V9H52.0106V9.07937C50.7143 9.79365 50.7143 10.7725 50.7143 12.1217V25.746C49.9206 25.4286 47.6719 23.6561 46.0846 21.5926C43.2275 17.8889 39.2328 12.7302 39.2328 12.7302V21.8307Z"
        fill="#006788"
      />
      <path
        d="M56.111 11.8571C56.111 10.746 56.0845 9.7672 54.8147 9.05291V9H59.9999V9.07937C58.7301 9.7672 58.7036 10.7989 58.7036 11.8836V22.0159C58.7036 23.1005 58.6771 24.1852 59.9999 24.8995V24.9788H54.8147V24.8995C56.1375 24.1852 56.111 23.1005 56.111 22.0159V11.8571Z"
        fill="#006788"
      />
    </svg>
  )
}

export default SvgBni
